export default __webpack_public_path__ + "static/Title_Background-74c1bb1236bc895b584b20cdfefd741d.png";